import React, { useMemo, useRef } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { getNextTabIndex, sortMobileTabs } from './SocietyInternalNav.utils';

const SocietyInternalNav = ({ activeSection, onSectionChange, society }) => {
  const { isAuthenticated } = useAuth();
  const tabRefs = useRef([]);

  const navigationItems = [
    {
      id: 'details',
      label: 'Details',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      public: true
    },
    {
      id: 'announcements',
      label: 'Announcements',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 4V2a1 1 0 011-1h8a1 1 0 011 1v2m0 0V1a1 1 0 011-1h2a1 1 0 011 1v18a1 1 0 01-1 1H4a1 1 0 01-1-1V1a1 1 0 011-1h2a1 1 0 011 1v3m0 0H5a1 1 0 00-1 1v16a1 1 0 001 1h14a1 1 0 001-1V5a1 1 0 00-1-1h-2" />
        </svg>
      ),
      public: true
    },
    {
      id: 'posts',
      label: 'Posts',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      ),
      public: true
    },
    {
      id: 'businesses',
      label: 'Businesses',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
      ),
      public: true
    },
    {
      id: 'events',
      label: 'Events',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      ),
      public: true,
    //   note: 'Public events only'
    },
    {
      id: 'property',
      label: 'Property',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      ),
      public: true,
    //   note: 'Public listings only'
    },
    {
      id: 'ads',
      label: 'Ads',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />
        </svg>
      ),
      public: true,
    //   note: 'Public ads only'
    },
    {
      id: 'free-items',
      label: 'Free/Exchange',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
      ),
      public: false,
    //   note: 'Login required'
    },
    {
      id: 'institutes',
      label: 'Institutes',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 14l9-5-9-5-9 5 9 5z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
        </svg>
      ),
      public: true
    },
    {
      id: 'mosques',
      label: 'Mosques',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
      ),
      public: true
    },
    {
      id: 'places',
      label: 'Places',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      ),
      public: true
    },
    {
      id: 'reviews',
      label: 'Reviews',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
        </svg>
      ),
      public: true
    }
  ];

  const filteredItems = navigationItems.filter((item) => item.public || isAuthenticated);
  const mobileItems = useMemo(() => sortMobileTabs(filteredItems), [filteredItems]);

  const handleTabKeyDown = (event, index, items) => {
    if (!['ArrowRight', 'ArrowLeft', 'Home', 'End', 'Enter', ' '].includes(event.key)) return;
    event.preventDefault();
    if (event.key === 'Enter' || event.key === ' ') {
      onSectionChange(items[index].id);
      return;
    }
    const nextIndex = getNextTabIndex({
      currentIndex: index,
      key: event.key,
      itemCount: items.length,
    });
    const nextItem = items[nextIndex];
    if (!nextItem) return;
    onSectionChange(nextItem.id);
    const nextRef = tabRefs.current[nextIndex];
    if (nextRef && typeof nextRef.focus === 'function') nextRef.focus();
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border">
      {/* Mobile Horizontal Navigation */}
      <div className="lg:hidden">
        <style>
          {`
            @keyframes society-mobile-tab-breathe {
              0%, 100% { transform: scale(1); }
              50% { transform: scale(1.045); }
            }
            .ss-mobile-tab-breathe {
              animation: society-mobile-tab-breathe 2.25s ease-in-out infinite;
              transform-origin: center center;
              backface-visibility: hidden;
            }
            @media (prefers-reduced-motion: reduce) {
              .ss-mobile-tab-breathe {
                animation: none !important;
              }
            }
          `}
        </style>
        <div className="px-2 pt-2">
          <div className="flex items-start justify-between gap-3 px-1">
            <div>
              <p className="text-[11px] font-semibold uppercase tracking-wide text-gray-500">
                Browse Society Sections
              </p>
              <p className="text-[11px] text-gray-500 mt-0.5">
                Swipe left or right to view all tabs
              </p>
            </div>
            <span className="text-[11px] font-medium text-blue-600 whitespace-nowrap mt-0.5">
              Swipe →
            </span>
          </div>
        </div>
        <div className="relative mt-1">
          <div className="overflow-x-auto scrollbar-hide px-2 pb-2" aria-label="Society sections">
            <nav className="flex space-x-1 py-1" role="tablist" aria-orientation="horizontal">
              {mobileItems.map((item, index) => {
                const isActive = activeSection === item.id;
                const tabId = `society-tab-${item.id}`;
                const panelId = `society-panel-${item.id}`;
                return (
                  <button
                    key={item.id}
                    id={tabId}
                    type="button"
                    role="tab"
                    aria-selected={isActive}
                    aria-controls={panelId}
                    tabIndex={isActive ? 0 : -1}
                    ref={(el) => {
                      tabRefs.current[index] = el;
                    }}
                    onClick={() => onSectionChange(item.id)}
                    onKeyDown={(event) => handleTabKeyDown(event, index, mobileItems)}
                    className={`flex items-center px-3 py-2 text-xs font-medium rounded-md whitespace-nowrap border transition-colors duration-200 ${
                      isActive
                        ? 'bg-blue-100 text-blue-700 border-blue-300 shadow-sm ss-mobile-tab-breathe'
                        : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100 border-transparent'
                    }`}
                  >
                    <span className="mr-1.5">{item.icon}</span>
                    <span>{item.label}</span>
                  </button>
                );
              })}
            </nav>
          </div>
          {/* Edge fades improve horizontal-scroll discoverability without blocking touch. */}
          <div className="pointer-events-none absolute left-0 top-0 h-full w-6 bg-gradient-to-r from-white to-transparent" />
          <div className="pointer-events-none absolute right-0 top-0 h-full w-6 bg-gradient-to-l from-white to-transparent" />
        </div>
      </div>

      {/* Desktop Vertical Navigation */}
      <div className="hidden lg:block">
        <nav className="flex flex-col">
          {filteredItems.map((item) => (
            <button
              key={item.id}
              onClick={() => onSectionChange(item.id)}
              className={`flex items-center px-4 py-3 text-sm font-medium transition-colors duration-200 ${
                activeSection === item.id
                  ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700'
                  : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
              }`}
            >
              <span className="mr-3">{item.icon}</span>
              <span className="flex-1 text-left">{item.label}</span>
              {item.note && (
                <span className="ml-2 text-xs text-gray-500">
                  {item.note}
                </span>
              )}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default SocietyInternalNav;
